import { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const WeightliftingSelectedIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="0.921875" y="6.41992" width="2.20509" height="9.15959" rx="1.10255" fill="#806FF7" />
    <rect x="3.12695" y="1.83984" width="2.20509" height="18.3192" rx="1.10255" fill="#806FF7" />
    <rect opacity="0.4" x="17.332" y="10" width="2" height="12" transform="rotate(90 17.332 10)" fill="#806FF7" />
    <rect width="2.20509" height="18.3192" rx="1.10255" transform="matrix(-1 0 0 1 19.5371 1.83984)" fill="#806FF7" />
    <rect width="2.20509" height="9.15959" rx="1.10255" transform="matrix(-1 0 0 1 21.7422 6.41992)" fill="#806FF7" />
  </svg>
)

export const WeightliftingIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="0.921875" y="6.41992" width="2.20509" height="9.15959" rx="1.10255" fill="#959693" />
    <rect x="3.12695" y="1.83984" width="2.20509" height="18.3192" rx="1.10255" fill="#959693" />
    <rect opacity="0.4" x="17.332" y="10" width="2" height="12" transform="rotate(90 17.332 10)" fill="#959693" />
    <rect width="2.20509" height="18.3192" rx="1.10255" transform="matrix(-1 0 0 1 19.5371 1.83984)" fill="#959693" />
    <rect width="2.20509" height="9.15959" rx="1.10255" transform="matrix(-1 0 0 1 21.7422 6.41992)" fill="#959693" />
  </svg>
)
